import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import { APIProvider as GoogleAPIProvider } from '@vis.gl/react-google-maps';
import ProduttivoMuiThemeV2 from '@/components/shared/themes/ProduttivoThemeV2'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/pt-br'
import {
  makeRemoteCreateNewRoute,
  makeRemoteLoadAccountMemberList, makeRemoteLoadCurrentAccount, makeRemoteLoadNewRouteSuggestion,
  makeRemoteLoadWorkList
} from '@/javascript/main/factories/usecases'
import RoutingCreate from '@/javascript/presentation/pages/routing/routing-create'
import { RoutingProvider } from '@/javascript/presentation/pages/routing/routing-context'

declare var _googleApiKey: string

const routingCreateEl = document.getElementById('routing-create-root')

export const makeRoutingCreate = () => {
  return(
    <ThemeProvider theme={ProduttivoMuiThemeV2}>
      <GoogleAPIProvider apiKey={_googleApiKey}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
          <RoutingProvider
            loadRouteSuggestion={makeRemoteLoadNewRouteSuggestion()}
            loadAccount={makeRemoteLoadCurrentAccount()}
            loadAccountMemberList={makeRemoteLoadAccountMemberList()}
            loadWorkList={makeRemoteLoadWorkList()}
            createNewRoute={makeRemoteCreateNewRoute()}
          >
            <RoutingCreate />
          </RoutingProvider>
        </LocalizationProvider>
      </GoogleAPIProvider>
    </ThemeProvider>
  )
}

if (routingCreateEl !== null) {
  const root = createRoot(routingCreateEl)
  root.render(makeRoutingCreate())
}
